var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifierPicto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6412 3.12638C19.108 6.63126 19.108 12.316 15.6412 15.8209C12.1775 19.3227 6.56386 19.3227 3.10008 15.8209C-0.366695 12.316 -0.366695 6.63126 3.10008 3.12638C6.56386 -0.375461 12.1775 -0.375461 15.6412 3.12638Z",
    stroke: "#1F3449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8052 15.9192L19.9998 20.0003",
    stroke: "#1F3449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierPicto);
export default __webpack_public_path__ + "static/media/magnifier_picto.eb0465ac161b0a6d977f46f119d4b0a1.svg";
export { ForwardRef as ReactComponent };